var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notifications_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.499 18.334c.916 0 1.666-.75 1.666-1.667H8.832c0 .917.75 1.667 1.667 1.667m5-5V9.167c0-2.558-1.359-4.7-3.75-5.266v-.567c0-.692-.559-1.25-1.25-1.25-.692 0-1.25.558-1.25 1.25v.567c-2.384.566-3.75 2.7-3.75 5.266v4.167l-1.667 1.667v.833h13.333v-.833zm-1.667.833H7.165v-5c0-2.066 1.259-3.75 3.334-3.75s3.333 1.684 3.333 3.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notifications_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgNotifications;